import React from 'react'

function Footer() {
    const style= {
        color: 'rgba(255, 255, 255, 0.5)',
        backgroundColor: '#000',
        marginBottom: '0px',
        testAlign: 'center',
        justifyContent: 'center',
        padding: '5px',
        display: 'flex',
      };
  return (
    <small style={style} >SRMIST VDP © 2022 - Designed by:-  <i> S PADMANABAN </i> </small>
  )
}

export default Footer